import React, { useEffect, useRef, useState } from 'react';
import ScopedStyle from './article.mobile.module.scss';
import { WebPNextImage as Image } from '../WebPImage';
import Link from 'next/link';
import router, { useRouter } from 'next/router';
import DocTemplate from '../../components/commonComponents/docTemplate';
import { Menu, Dropdown, Drawer, Tree } from 'antd';
import { Popup } from 'antd-mobile';
import { groupBy } from 'lodash';
import request from '../../utils/request/next-request';
import debounce from 'lodash/debounce';
import { WHITE_LIST } from '../docPageComponents/commonCard/common-card';
import { ITopDoc } from '../docPageComponents/product-guideline/ProductGuidelineCard';

const { SubMenu } = Menu;

const productIcon = '/img/doc-center/dianboyunIcon.svg';

const recursion = (navigation, callback = (item, path) => {}, path = []) => {
  navigation.map((item) => {
    path.push(item.title);
    item.children && recursion(item.children, callback, path);
    callback(item, path);
    path.pop();
  });
};

const handleTitleClick = async (
  productId: string,
  productName: string,
  productCode: string,
  docId: string
) => {
  router.push(`/document/${productCode}/${docId || ''}`);
};

const moveBackToDocListPage = () => {
  router.push(`/document`);
};

const DocNav = (props: { topDocs: any; activeProductCode: string }) => {
  const { topDocs, activeProductCode } = props;
  const topDocsByType: {
    [productType: string]: {
      docsUpdateTime: number;
      firstType: string;
      id: number;
      productCode: string;
      productName: string;
      secondType: string;
      topDocs: { docsKey: string }[];
    }[];
  } = groupBy(topDocs, 'firstType');
  return (
    <>
      {Object.keys(topDocsByType).map((productType: string) => (
        <div className={ScopedStyle['dropdown-card']} key={productType}>
          <div className={ScopedStyle['dropdown-card-title']}>
            {productType}
          </div>
          <div className={ScopedStyle['dropdown-card-list']}>
            {topDocsByType[productType]
              .filter(({ productCode }) => {
                // COPY FROM components/docPageComponents/commonCard/common-card.tsx
                if (productType !== 'StreamLake-Video') {
                  return true;
                }

                if (WHITE_LIST.includes(productCode)) {
                  return true;
                }
              })
              .map(({ id, productName, productCode, topDocs }) => (
                <div
                  key={id}
                  className={`${ScopedStyle['dropdown-card-button-item']} ${
                    activeProductCode === productCode
                      ? ScopedStyle['active']
                      : ''
                  }`}
                  onClick={() =>
                    handleTitleClick(
                      String(id),
                      productName,
                      productCode,
                      topDocs[0]?.docsKey
                    )
                  }
                >
                  {productName}
                </div>
              ))}
          </div>
        </div>
      ))}
    </>
  );
};

const DownArrow = (props: { style: React.CSSProperties }) => {
  const { style = {} } = props;
  return (
    <div style={{ ...style, position: 'relative' }}>
      <Image
        src={'/img/doc-center/arrowDown.svg'}
        layout="fill"
        alt="down"
      ></Image>
    </div>
  );
};

const LeftArrow = (props: { style: React.CSSProperties }) => {
  const { style = {} } = props;
  return (
    <div style={{ ...style, position: 'relative', transform: 'scaleX(-1)' }}>
      <Image
        src={'/img/doc-center/arrowRight.svg'}
        layout="fill"
        alt="left"
      ></Image>
    </div>
  );
};

const handleTreeSelect = (node, productCode) => {
  if (node.docId) {
    router.push(`/document/${productCode}/${node.docId}`);
  } else {
    // todo 展开
  }
};

// 获取当前选中的目录
const getCurrentNav = (key, navigation) => {
  let titles = [];

  recursion(navigation, (item, path) => {
    if (item.key === key) {
      titles = [...path];
    }
  });

  return titles;
};

const ArticleToc = (props: {
  visible: boolean;
  onClose: () => void;
  docsKey: string;
  productCode: string;
  navigation: any;
  topDocs: ITopDoc[];
}) => {
  const {
    visible,
    navigation,
    docsKey,
    productCode,
    onClose = () => void 0,
  } = props;
  const router = useRouter();
  const treeRef = useRef<any>();

  const [currentMenuKey] = useState(docsKey as string);

  // 获取目录的默认值
  const titles = getCurrentNav(currentMenuKey, navigation);

  // 实现点击 treeNode 即展开 folder 效果
  // https://github.com/ant-design/ant-design/issues/27507#issuecomment-751630602
  const expandFolderNode = (
    event: React.MouseEvent<HTMLElement>,
    node: any
  ) => {
    const { isLeaf } = node;

    if (isLeaf || event.shiftKey || event.metaKey || event.ctrlKey) {
      return;
    }

    // Call internal rc-tree expand function
    // https://github.com/ant-design/ant-design/issues/12567
    treeRef.current!.onNodeExpand(event as any, node);
  };

  const onDebounceExpand = debounce(expandFolderNode, 200, {
    leading: true,
  });

  const onClick = (
    event: React.MouseEvent<HTMLElement>,
    node: any
    // EventDataNode
  ) => {
    onDebounceExpand(event, node);
  };

  return (
    // <Drawer visible={true}></Drawer>
    <Popup
      // title=
      position={'left'}
      onClose={onClose}
      closeOnMaskClick={true}
      visible={visible}
      className={ScopedStyle['drawler-toc-mobile']}
      style={{ width: '2.8rem' }}
      // key={placement}
    >
      <div
        className={ScopedStyle['drawler-toc-title']}
        onClick={() => moveBackToDocListPage()}
      >
        <div className={ScopedStyle['left-arrow']} />
        文档首页
      </div>
      <div className={ScopedStyle['drawer-toc-title-division']} />
      <div className={ScopedStyle['drawer-toc-tree']}>
        <Tree
          ref={treeRef}
          key={currentMenuKey}
          treeData={navigation}
          defaultExpandedKeys={[currentMenuKey]}
          defaultSelectedKeys={[currentMenuKey]}
          onSelect={(_, e) => handleTreeSelect(e.node, productCode)}
          rootClassName={ScopedStyle['drawer-toc-tree-menu']}
          onClick={onClick}
          titleRender={(nodeData) => (
            <span
              className={
                ScopedStyle[`tree-node-level-${(nodeData as any).level}`]
              }
            >
              {nodeData.title}
            </span>
          )}
        />
      </div>
    </Popup>
  );
};

export const ArticleHeader = (props: {
  showCategoryTrigger?: boolean;
  onTriggerCategory: () => void;
  productCode: string;
  productName: string;
  topDocs: any;
}) => {
  const {
    showCategoryTrigger = true,
    topDocs,
    productCode = '',
    productName = '',
    onTriggerCategory = () => undefined,
  } = props;
  const [isDropDownShow, setIsDropDownShow] = useState(false);

  const headerRef = useRef<HTMLSpanElement>();
  return (
    <>
      {isDropDownShow && (
        <div
          className={ScopedStyle.mask}
          onClick={() => setIsDropDownShow(false)}
        />
      )}
      <Dropdown
        visible={isDropDownShow}
        overlay={
          <div className={ScopedStyle.dropdown}>
            <DocNav topDocs={topDocs} activeProductCode={productCode} />
          </div>
        }
        getPopupContainer={() => document.getElementById('drop-down-anchor')}
        autoAdjustOverflow={false}
      >
        <span
          id="drop-down-anchor"
          className={ScopedStyle.header}
          ref={(r) => (headerRef.current = r)}
        >
          {showCategoryTrigger && (
            <div
              className={ScopedStyle.toc}
              onClick={() => onTriggerCategory()}
            >
              目录
            </div>
          )}
          <div
            className={ScopedStyle.name}
            onClick={() => setIsDropDownShow((v) => !v)}
          >
            {productName}
            <div className={ScopedStyle['down-arrow']} />
          </div>
        </span>
      </Dropdown>
    </>
  );
};

export default function Article({
  document,
  navigation,
  product,
  topDocs,
  docsKey,
  ...otherProps
}: {
  document: { releaseAt: number; draft: string; html: string };
  navigation: any;
  topDocs: any;
  docsKey: string;
  product: { productName: string; productCode: string };
}) {
  const currentMenuKey = docsKey;
  const [isCategoryShow, setIsCategoryShow] = useState(false);

  // 获取目录的默认值
  const titles = getCurrentNav(currentMenuKey, navigation);

  return (
    <div className={ScopedStyle.wrapper}>
      <div className={ScopedStyle.container}>
        <ArticleHeader
          //NOTE: 每次 dockey 变更, 都会销毁原来已展开的 Header, 恢复默认状态
          key={'header' + docsKey}
          onTriggerCategory={() => setIsCategoryShow(true)}
          productCode={product.productCode}
          productName={product.productName}
          topDocs={topDocs}
        />

        <ArticleToc
          key={'toc' + docsKey}
          docsKey={docsKey}
          productCode={product.productCode}
          visible={isCategoryShow}
          navigation={navigation}
          topDocs={topDocs}
          onClose={() => setIsCategoryShow(false)}
        />
        <DocTemplate
          title={titles[titles.length - 1]}
          time={document.releaseAt}
          content={document.draft}
          html={document.html}
          showAnchor={false}
        />
      </div>
    </div>
  );
}
